import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { AIDES_PROFESSIONNELS } from '../../../../config/aides-professionnels';

export default function PretsBpifrancePage() {
  const aide = AIDES_PROFESSIONNELS.find((a) => a.slug === 'prets-bpifrance');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="professionnels" />;
}
